import { OKSDK } from './OKSDK';

const oksdk = new OKSDK();

// Export typings
export * from './types';

export { oksdk as default };
